import { toast } from 'react-toastify';

const toastStyle = {
  display: 'flex',
  alignItems: 'center',
};

export const toastAlert = ({ msg = 'Toast!!', isError = false }) => {
  if (!isError) {
    toast.success(<SuccessToast msg={msg} />, {
      className: 'toastify-success',
    });
  } else {
    toast.error(<ErrorToast msg={msg} />, {
      className: 'toastify-error',
    });
  }
};

export const SuccessToast = ({ msg = 'Toasty' }) => (
  <div style={toastStyle}>{msg}</div>
);

export const ErrorToast = ({ msg = 'Toasty' }) => (
  <div style={toastStyle}>{msg}</div>
);
